import { TEAM_SET_PROPS } from "actions";
import { propsReducer } from "utils/stateUtils";

const DEFAULT_STATE = {
    teams: [],
    teamDetails: null
};

export default propsReducer(TEAM_SET_PROPS, DEFAULT_STATE);
